import React from "react";
import SecondDraft from "../modules/SecondDraft/SecondDraft.jsx";

const Seconddraft = () => {
	return <SecondDraft />;
};

export default Seconddraft;